import { useState, useRef, useEffect } from "react";
import Button from "components/BaseWidgets/button";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import defaultImage from "assets/images/png/default-user.png";
import DOMPurify from "dompurify";

const StoryCard = ({ id, title, description, date, image }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const descRef = useRef(null);
  const navigate = useNavigate();

  // Check if the rendered HTML actually overflows the clamped height
  useEffect(() => {
    if (descRef.current) {
      setIsClamped(
        descRef.current.scrollHeight > descRef.current.clientHeight
      );
    }
  }, [description]);

  const handleClick = () => {
    navigate(`/success-stories/details/${id}`);
  };

  const handleLinkClick = (e) => {
    const target = e.target.closest("a");
    if (target) {
      e.preventDefault();
      e.stopPropagation();
      const url = target.getAttribute("href");
      if (url) {
        window.open(
          /^https?:\/\//i.test(url) ? url : `https://${url}`,
          "_blank",
          "noopener,noreferrer"
        );
      }
    }
  };

  return (
    <div className="StoryCard-card">
      <div className="image-wrapper" onClick={handleClick}>
        <img
          src={image ? image : defaultImage}
          alt="Bridal Jewellery"
          className="image"
        />
      </div>
      <div className="content">
        <p className="mb-1 font-title-xs fw-700">{title}</p>
        <p className="date font-body-normal fw-400">Posted on: {date}</p>

        <div
          ref={descRef}
          className={`description font-title-xs fw-400 ${!isExpanded ? "description--clamped" : ""}`}
          onClick={handleLinkClick}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(description || "", {
              ADD_ATTR: ["target", "rel"],   // keep target="_blank" & rel from editor
            }),
          }}
        />

        {/* Show button only if content actually overflows OR is already expanded */}
        {(isClamped || isExpanded) && (
          <Button
            variant="link"
            className="readMore"
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            {isExpanded ? "Read less" : "Read more"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default StoryCard;
